// apps/web/src/tour/useTourController.ts
import { useEffect } from 'react';
import { useTourStore } from '@/state/tourStore';
import { useBrainStore } from '@/state/brainStore';
import { TOURS } from '@/tour/messengerTour';
import { resolveActiveStep, type TourCtx } from '@/tour/tourTypes';

/** Mount once high in the tree. Re-syncs the active step on brainStore changes
 *  and on a light interval (catches DOM-only transitions: tab, modal, slot). */
export function useTourController() {
  useEffect(() => {
    const tick = () => {
      const st = useTourStore.getState();
      if (!st.enabled || !st.activeTourId || !st.activeCustomerId || !st.baseline) return;
      const tour = TOURS[st.activeTourId];
      if (!tour) return;
      const ctx: TourCtx = {
        customer: useBrainStore.getState().customers[st.activeCustomerId],
        baseline: st.baseline,
        el: (sel) => document.querySelector(sel),
      };
      const res = resolveActiveStep(tour, ctx);
      if (res.kind === 'active') {
        if (res.step.id !== st.activeStepId) {
          st.setActiveStep(res.step.id);
          if (res.step.autoScroll) {
            document.querySelector(res.step.anchor)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        }
      } else {
        st.complete(st.activeTourId, res.kind === 'handoff' ? 'handoff' : 'complete');
      }
    };
    const unsub = useBrainStore.subscribe(tick);
    const iv = setInterval(tick, 500);
    tick();
    return () => {
      unsub();
      clearInterval(iv);
    };
  }, []);
}
